module.exports = "<div >{{ time | date: 'HH:mm:ss a' }}</div>"